module.exports = __webpack_public_path__ + "static/img/wdzt1-7.ad57ef3.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-7.png
// module id = 856
// module chunks = 0